/**
 * External dependencies
 */

/**
 * Internal dependencies
 */
import { SET_CONTACT_INITIALIZE, SET_CONTACT_INFO } from '@naruto/bgdapp/src/reducers/cores/contact/actions';
import { errorCatch } from '@naruto/bgdapp/src/reducers/_Capture/errorCapture';
import { Dispatch, ThunkAction, Models, MiddleWare, ContactInfo } from './types';

/* Initial */
/**
 * 初始化管理 store 資料
 */
export const postContactInitialize =
  (): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch(SET_CONTACT_INITIALIZE());
  };

/**
 * 取得聯絡資訊
 */
export const getContactInfo =
  (): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch, getState, { api }): Promise<void> => {
    const result = await api.contact.getContactInfo<ContactInfo>();
    if (!result.error && result.response) {
      dispatch(SET_CONTACT_INFO({ contactInfo: result.response }));
    } else {
      const oldState = getState().contact.contactInfo;
      if (oldState) {
        dispatch(SET_CONTACT_INFO({ contactInfo: { ...oldState } }));
      } else {
        dispatch(
          SET_CONTACT_INFO({
            contactInfo: {
              contact: {
                ctime: '',
                mtime: ''
              }
            }
          })
        );
      }
    }
    await dispatch(errorCatch(result.error, result.status));
  };
